import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // Immediate scroll, no animation
    });
  }, [pathname]); // Trigger on pathname change

  return null; // This component doesn't render anything
};

export default ScrollToTop;